
export default {

    get(item) {
        let calif = 0;
        let map = {
            photo: 0, // 5
            personalSlogan: 0, // 5
            pda: 0, // 10
            molecule: { 
                total: 0, // 20
                attributes: 0, // 5
                feelings: 0, // 5
                interests: 0, // 5
                goodAt: 0 // 5
            },
            mapOfLife: {
                total: 0, // 20
                a15: { // 5
                    vision: 0, // 3
                    obj1: 0, // 0.5
                    obj2: 0, // 0.5
                    obj3: 0, // 0.5
                    obj4: 0 // 0.5
                }, 
                a10: { // 5
                    vision: 0, // 3
                    obj1: 0, // 0.5
                    obj2: 0, // 0.5
                    obj3: 0, // 0.5
                    obj4: 0 // 0.5
                },
                a5: { // 5
                    vision: 0, // 3
                    obj1: 0, // 0.5
                    obj2: 0, // 0.5
                    obj3: 0, // 0.5
                    obj4: 0 // 0.5
                },
                a1: { // 5
                    vision: 0, // 3
                    obj1: 0, // 0.5
                    obj2: 0, // 0.5
                    obj3: 0, // 0.5
                    obj4: 0 // 0.5
                },
            },
            top3: {
                total: 0, // 20
                professions: 0, // 5
                majors: 0, // 5
                univs: 0, // 5
                companies: 0, // 5
            },
            reputationPlanner: { 
                total: 0, // 20
                headline: 0, // 1
                slogan: 0, // 1
                services: 0, // 1
                contactInfo: 0, // 1
                about: 0, // 1
                skills: 0, // 1
                interests: 0, // 1
                languages: 0, // 1
                experience: 0, // 1
                volunteer: 0, // 1
                education: 0, // 1
                organizations: 0, // 1
                courses: 0, // 1
                projects: 0, // 2
                honors: 0, // 1
                contacts_professions: 0, // 1
                contacts_majors: 0, // 1
                contacts_univs: 0, // 1
                contacts_companies: 0 // 1
            }
        };

        // Photo
        if (item.photo != null) {
            calif += 5;
            map.photo = 5;
        }
        
        // Personal slogan
        if (item.bio && item.bio.length>0) {
            calif += 5;
            map.personalSlogan = 5;
        }

        // PDA
        if (item.pda && item.pda.length>0) {
            calif += 10;
            map.pda = 10;
        }

        // MOLECULE ------------------------------------------------------------------------------------------------------------------------
        // ATTRIBUTES
        if (item.attributes) {
            calif += 5;
            map.molecule.attributes = 5;
            map.molecule.total += 5;
        }
        // FEEELINGS
        if (item.concepts && item.concepts.feeling && item.concepts.feeling.c1 && item.concepts.feeling.c2 && item.concepts.feeling.c3) {
            calif += 5;
            map.molecule.feelings = 5;
            map.molecule.total += 5;
        }
        // INTERESTS
        if (item.concepts && item.concepts.interestedIn && item.concepts.interestedIn.c1 && item.concepts.interestedIn.c2 && item.concepts.interestedIn.c3) {
            calif += 5;
            map.molecule.interests = 5;
            map.molecule.total += 5;
        }
        // GOOD AT
        if (item.concepts && item.concepts.goodAt && item.concepts.goodAt.c1 && item.concepts.goodAt.c2 && item.concepts.goodAt.c3) {
            calif += 5;
            map.molecule.goodAt = 5;
            map.molecule.total += 5;
        }

        // MAP OF LIFE ------------------------------------------------------------------------------------------------------------------------
        if (item.goals) {
            // 15 YEARS ---
            if (item.goals.t15) {
                // Vision
                if (item.goals.t15.vision && item.goals.t15.vision.length>0) {
                    calif += 3;
                    map.mapOfLife.a15.vision = 3;
                    map.mapOfLife.total += 3;
                }
                // Objectives
                if (item.goals.t15.resourcesYes && item.goals.t15.resourcesNo && item.goals.t15.actions) {
                    // Objective 1
                    if (item.goals.t15.goals[0]) {
                        if (item.goals.t15.resourcesYes.g0 && item.goals.t15.resourcesNo.g0)
                        if (item.goals.t15.resourcesYes.g0.length >= 2 && item.goals.t15.resourcesNo.g0.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a15.obj1 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 2
                    if (item.goals.t15.goals[1]) {
                        if (item.goals.t15.resourcesYes.g1 && item.goals.t15.resourcesNo.g1)
                        if (item.goals.t15.resourcesYes.g1.length >= 2 && item.goals.t15.resourcesNo.g1.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a15.obj2 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 3
                    if (item.goals.t15.goals[2]) {
                        if (item.goals.t15.resourcesYes.g2 && item.goals.t15.resourcesNo.g2)
                        if (item.goals.t15.resourcesYes.g2.length >= 2 && item.goals.t15.resourcesNo.g2.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a15.obj3 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 4
                    if (item.goals.t15.goals[3]) {
                        if (item.goals.t15.resourcesYes.g3 && item.goals.t15.resourcesNo.g3)
                        if (item.goals.t15.resourcesYes.g3.length >= 2 && item.goals.t15.resourcesNo.g3.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a15.obj4 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                }
            }
            // 10 YEARS ---
            if (item.goals.t10) {
                // Vision
                if (item.goals.t10.vision && item.goals.t10.vision.length>0) {
                    calif += 3;
                    map.mapOfLife.a10.vision = 3;
                    map.mapOfLife.total += 3;
                }
                // Objectives
                if (item.goals.t10.resourcesYes && item.goals.t10.resourcesNo && item.goals.t10.actions) {
                    // Objective 1
                    if (item.goals.t10.goals[0]) {
                        if (item.goals.t10.resourcesYes.g0 && item.goals.t10.resourcesNo.g0)
                        if (item.goals.t10.resourcesYes.g0.length >= 2 && item.goals.t10.resourcesNo.g0.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a10.obj1 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 2
                    if (item.goals.t10.goals[1]) {
                        if (item.goals.t10.resourcesYes.g1 && item.goals.t10.resourcesNo.g1)
                        if (item.goals.t10.resourcesYes.g1.length >= 2 && item.goals.t10.resourcesNo.g1.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a10.obj2 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 3
                    if (item.goals.t10.goals[2]) {
                        if (item.goals.t10.resourcesYes.g2 && item.goals.t10.resourcesNo.g2)
                        if (item.goals.t10.resourcesYes.g2.length >= 2 && item.goals.t10.resourcesNo.g2.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a10.obj3 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 4
                    if (item.goals.t10.goals[3]) {
                        if (item.goals.t10.resourcesYes.g3 && item.goals.t10.resourcesNo.g3)
                        if (item.goals.t10.resourcesYes.g3.length >= 2 && item.goals.t10.resourcesNo.g3.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a10.obj4 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                }
            }
            // 5 YEARS ---
            if (item.goals.t5) {
                // Vision
                if (item.goals.t5.vision && item.goals.t5.vision.length>0) {
                    calif += 3;
                    map.mapOfLife.a5.vision = 3;
                    map.mapOfLife.total += 3;
                }
                // Objectives
                if (item.goals.t5.resourcesYes && item.goals.t5.resourcesNo && item.goals.t5.actions) {
                    // Objective 1
                    if (item.goals.t5.goals[0]) {
                        if (item.goals.t5.resourcesYes.g0 && item.goals.t5.resourcesNo.g0)
                        if (item.goals.t5.resourcesYes.g0.length >= 2 && item.goals.t5.resourcesNo.g0.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a5.obj1 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 2
                    if (item.goals.t5.goals[1]) {
                        if (item.goals.t5.resourcesYes.g1 && item.goals.t5.resourcesNo.g1)
                        if (item.goals.t5.resourcesYes.g1.length >= 2 && item.goals.t5.resourcesNo.g1.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a5.obj2 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 3
                    if (item.goals.t5.goals[2]) {
                        if (item.goals.t5.resourcesYes.g2 && item.goals.t5.resourcesNo.g2)
                        if (item.goals.t5.resourcesYes.g2.length >= 2 && item.goals.t5.resourcesNo.g2.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a5.obj3 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 4
                    if (item.goals.t5.goals[3]) {
                        if (item.goals.t5.resourcesYes.g3 && item.goals.t5.resourcesNo.g3)
                        if (item.goals.t5.resourcesYes.g3.length >= 2 && item.goals.t5.resourcesNo.g3.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a5.obj4 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                }
            }
            // 1 YEAR ---
            if (item.goals.t1) {
                // Vision
                if (item.goals.t1.vision && item.goals.t1.vision.length>0) {
                    calif += 3;
                    map.mapOfLife.a1.vision = 3;
                    map.mapOfLife.total += 3;
                }
                // Objectives
                if (item.goals.t1.resourcesYes && item.goals.t1.resourcesNo && item.goals.t1.actions) {
                    // Objective 1
                    if (item.goals.t1.goals[0]) {
                        if (item.goals.t1.resourcesYes.g0 && item.goals.t1.resourcesNo.g0)
                        if (item.goals.t1.resourcesYes.g0.length >= 2 && item.goals.t1.resourcesNo.g0.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a1.obj1 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 2
                    if (item.goals.t1.goals[1]) {
                        if (item.goals.t1.resourcesYes.g1 && item.goals.t1.resourcesNo.g1)
                        if (item.goals.t1.resourcesYes.g1.length >= 2 && item.goals.t1.resourcesNo.g1.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a1.obj2 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 3
                    if (item.goals.t1.goals[2]) {
                        if (item.goals.t1.resourcesYes.g2 && item.goals.t1.resourcesNo.g2)
                        if (item.goals.t1.resourcesYes.g2.length >= 2 && item.goals.t1.resourcesNo.g2.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a1.obj3 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                    // Objective 4
                    if (item.goals.t1.goals[3]) {
                        if (item.goals.t1.resourcesYes.g3 && item.goals.t1.resourcesNo.g3)
                        if (item.goals.t1.resourcesYes.g3.length >= 2 && item.goals.t1.resourcesNo.g3.length >= 2) {
                            calif += 0.5;
                            map.mapOfLife.a1.obj4 = 0.5;
                            map.mapOfLife.total += 0.5;
                        }
                    }
                }
            }
        }

        // TOP 3 ------------------------------------------------------------------------------------------------------------------------
        if (item.mytop) {
            if (item.mytop.professions) {
                calif += 5;
                map.top3.professions = 5;
                map.top3.total += 5;
            }
            if (item.mytop.majors) {
                calif += 5;
                map.top3.majors = 5;
                map.top3.total += 5;
            }
            if (item.mytop.universities) {
                calif += 5;
                map.top3.univs = 5;
                map.top3.total += 5;
            }
            if (item.mytop.companies) {
                calif += 5;
                map.top3.companies = 5;
                map.top3.total += 5;
            }
        }

        // REPUTATION PLANNER ------------------------------------------------------------------------------------------------------------------------
        if (item.planner) {
            if (item.planner.headline && item.planner.headline.length>0) {
                calif += 1;
                map.reputationPlanner.headline = 1;
                map.reputationPlanner.total += 1;
            }  

            if (item.planner.slogan && item.planner.slogan.length>0) {
                calif += 1;
                map.reputationPlanner.slogan = 1;
                map.reputationPlanner.total += 1;
            } 
            
            if (item.planner.providingServices && item.planner.providingServices.length>0) {
                calif += 1;
                map.reputationPlanner.services = 1;
                map.reputationPlanner.total += 1;
            } 

            if (item.planner.contactInfo && item.planner.contactInfo.length>0) {
                calif += 1;
                map.reputationPlanner.contactInfo = 1;
                map.reputationPlanner.total += 1;
            } 

            if (item.planner.about && item.planner.about.length>0) {
                calif += 1;
                map.reputationPlanner.about = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.skills && item.planner.skills.length>0) {
                calif += 1;
                map.reputationPlanner.skills = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.interests && item.planner.interests.length>0) {
                calif += 1;
                map.reputationPlanner.interests = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.languages && item.planner.languages.length>0) {
                calif += 1;
                map.reputationPlanner.languages = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.experience && item.planner.experience.length>0) {
                calif += 1;
                map.reputationPlanner.experience = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.volunteerExperience && item.planner.volunteerExperience.length>0) {
                calif += 1;
                map.reputationPlanner.volunteer = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.education && item.planner.education.length>0) {
                calif += 1;
                map.reputationPlanner.education = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.organizations && item.planner.organizations.length>0) {
                calif += 1;
                map.reputationPlanner.organizations = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.courses && item.planner.courses.length>0) {
                calif += 1;
                map.reputationPlanner.courses = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.projects && item.planner.projects.length>0) {
                calif += 2;
                map.reputationPlanner.projects = 2;
                map.reputationPlanner.total += 2;
            }

            if (item.planner.honors && item.planner.honors.length>0) {
                calif += 1;
                map.reputationPlanner.honors = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.professions) {
                calif += 1;
                map.reputationPlanner.contacts_professions = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.majors) {
                calif += 1;
                map.reputationPlanner.contacts_majors = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.universities) {
                calif += 1;
                map.reputationPlanner.contacts_univs = 1;
                map.reputationPlanner.total += 1;
            }

            if (item.planner.companies) {
                calif += 1;
                map.reputationPlanner.contacts_companies = 1;
                map.reputationPlanner.total += 1;
            }
        }

        return {calif: calif, map: map};
    }

}